import React, {Component} from 'react';
import { extend } from 'lodash';
import POIBadges from './POIListItems/POIBadges';
import POICertification from './POIListItems/POICertification';
import POICost from './POIListItems/POICost';
import POICuisine from './POIListItems/POICuisine';
import POIInfo from './POIListItems/POIInfo';
import POILogo from './POIListItems/POILogo';
import POIHotelStars from './POIListItems/POIHotelStars';
import POIRating from './POIListItems/POIRating';
import POIReviewCount from './POIListItems/POIReviewCount';
import './poi_search';

class POIListItem extends Component {
  constructor(props) {
    super();
  }

  render (){
    const {bemBlocks, result} = this.props;
    let resultType = result._type == 'attraction' ? 'things_to_do' : result._type + 's';
    let url = '/' + resultType + '/' + result._source.slug;
    const source:any = extend({}, result._source, result.highlight);

    const ifHotel = result._type == "hotel",
          ifMosque = result._type == "mosque";

    const ifBadgesExists = result._source.badges_urls.length >= 1,
          ifCertificationExists = result._source.certification_url,
          ifCuisineExists = result._source.cuisines,
          ifLogoExists = result._source.logo_url,
          ifStarsExists = result._source.stars,
          ifCostExists = result._source.cost,
          ifReviewExists = result._source.reviews_count >= 1;

    return (
      <a href={url} className={bemBlocks.item().mix(bemBlocks.container('item'))} data-qa='hit'>
        <div className={bemBlocks.item('poster')}>
          <img alt='presentation' data-qa='poster' src={result._source.photo_url} />
          { ifReviewExists &&
            <POIReviewCount {...result} />
          }
        </div>
        <div className={bemBlocks.item('details')}>
          <POIInfo {...result} />
          { ifCuisineExists &&
            <POICuisine {...result} />
          }
          { ifHotel &&
            ifStarsExists &&
            <POIHotelStars {...result} />
          }
          { !ifHotel &&
            ifCostExists &&
            <POICost {...result} />
          }
          { ifBadgesExists &&
            <POIBadges {...result} />
          }
        </div>
        <div className={bemBlocks.item('mid-column')}>
          { ifLogoExists &&
            <POILogo {...result} />
          }
          { ifCertificationExists &&
            <POICertification {...result}/>
          }
        </div>
        { !ifMosque &&
          <POIRating {...result} />
        }
      </a>
    )
  }
}

export default POIListItem;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/poi_list_item.jsx